// frontend/components/sidebar/SidebarProfile.tsx

"use client";

interface SidebarProfileProps {
  user: any;
  isNeutral: boolean;
  onClick?: () => void;
}

export default function SidebarProfile({ user, isNeutral, onClick }: SidebarProfileProps) {
  if (!user) {
    return (
      <div className={`flex items-center space-x-3 px-2 py-2 rounded-lg border mx-1 animate-pulse ${isNeutral ? 'bg-gray-200/50 border-gray-200 dark:bg-white/5 dark:border-zinc-800' : 'bg-black/10 border-white/5'}`}>
        <div className={`w-8 h-8 rounded shrink-0 ${isNeutral ? 'bg-gray-300 dark:bg-white/10' : 'bg-white/20'}`}></div>
        <div className="flex-1 min-w-0 space-y-2">
          <div className={`h-3.5 rounded w-1/2 ${isNeutral ? 'bg-gray-300 dark:bg-white/10' : 'bg-white/20'}`}></div>
          <div className={`h-2.5 rounded w-3/4 ${isNeutral ? 'bg-gray-300 dark:bg-white/10' : 'bg-white/20'}`}></div>
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      className={`flex items-center space-x-3 px-2 py-2 rounded-lg transition-colors border mx-1 ${onClick ? 'cursor-pointer' : ''} ${isNeutral ? 'bg-gray-200/50 hover:bg-gray-200 border-gray-200 dark:bg-white/5 dark:hover:bg-white/10 dark:border-zinc-800' : 'bg-black/10 hover:bg-black/20 border-white/5'}`}
    >
      <div className={`w-8 h-8 rounded flex items-center justify-center font-bold text-sm shrink-0 ${isNeutral ? 'bg-white dark:bg-black/20 shadow-sm' : 'bg-black/20'}`}>
        {user.name?.slice(0, 2) || "U"}
      </div>
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-bold truncate ${isNeutral ? 'text-gray-900 dark:text-gray-100' : 'text-white'}`}>
          {user.name}
        </p>
        <p className={`text-[11px] truncate ${isNeutral ? 'text-gray-500 dark:text-gray-400' : 'text-white/60'}`}>
          {user.department || "소속 없음"} · {user.role}
        </p>
      </div>
    </div>
  );
}
